<template>
  <footer class="footer footer-static footer-light navbar-shadow mt-auto ">
    <div class="clearfix blue-grey lighten-2 mb-0">
				<span class="float-md-left d-block d-md-inline-block  mr-3">
					<img src="/img/logo.svg" alt="" style="height: 20px">
				</span>
      <router-link :to="{'name':'dashboard'}" class="btn-link btn py-25 mt-25 px-1">
        {{ lexicon.drop_stat_title }}
      </router-link>

      <router-link :to="{'name':'orders'}" class="btn-link btn py-25 mt-25 px-1">
        {{ lexicon.drop_orders }}
      </router-link>

      <router-link :to="{'name':'payments'}" class="btn-link btn py-25 mt-25 px-1">
        {{ lexicon.drop_payments }}
      </router-link>
      <router-link :to="{'name':'settings'}" class="btn-link btn py-25 mt-25 px-1">
        {{ lexicon.drop_settings }}
      </router-link>
      <a href="/assets/drop.pdf" target="_blank" class="btn-link btn py-25 mt-25 px-1">
        {{ lexicon.drop_terms }}

      </a>
      <router-link :to="{'name':'remains'}" class="btn-link btn py-25 mt-25 px-1">
        {{ lexicon.drop_renains_and_photos }}
      </router-link>
      <a href="#" class="btn-link btn py-25 mt-25 px-1" @click.prevent="showContacts()">
        {{ lexicon.drop_contacts }}
      </a>
    </div>
    <div id="contactsModal" ref="contactsModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ lexicon.drop_contacts }}</h4>
          </div>
          <div class="modal-body text-left">

            <div class="row">
              <div class="col-12 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">Менеджер по дропшиппингу</h5>
                    <p class="card-text">
                      Грынив Ирина
                      <br>
                      +380 67 507 37 25
                      <br>
                      <small>(Viber/Telegram)</small>
                    </p>
                    <a href="tel:+380 67 507 37 25" target="_blank" class="btn btn-success">
                      <i class="feather icon-phone-call"></i>
                      {{ lexicon.drop_call }}
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">СЕО Brushme</h5>
                    <p class="card-text">
                      Кравец Андрей
                      <br>
                      +380 95 43 095 23
                      <br>
                      <small>(Viber/Telegram)</small>
                    </p>
                    <a href="tel:+380 95 43 095 23" target="_blank" class="btn btn-success">
                      <i class="feather icon-phone-call"></i>
                      {{ lexicon.drop_call }}

                    </a>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark " data-dismiss="modal" @click="closeContacts()">
              {{ lexicon.drop_close }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="salesModal" ref="salesModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-body text-left">

            <div class="row">
              <div class="col-12 " v-if="user.settings.showSale">
                <img :src="user.settings.showSaleImg" class="img-fluid" alt="">
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark " data-dismiss="modal" @click="closeSale()">
              {{ lexicon.drop_close }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show d-none" ref="backdropModal"></div>
  </footer>
</template>

<script>
import {mapGetters, mapState, mapActions} from 'vuex'
import toast from "@/helpers/toast";


export default {
  computed: {
    ...mapGetters({
      app_upgraded: 'auth/app_upgraded',
      user: 'auth/user',
      showBNR: 'auth/showBNR',

    }),
    ...mapState({
      lexicon: 'lexicon',
    })
  },
  watch: {
    app_upgraded: function (status) {
      if (status) {
        toast.info('<a href="' + location.href + '">' + this.lexicon.drop_app_upgraded_bnt + ' </a>', this.lexicon.drop_app_upgraded_title, true)
      }
    },
    showBNR: function (bnr) {
      if (bnr) {
        this.showSale();
      }
    },
  },
  mounted() {
    if (this.user.settings.showSale) {
      if (!localStorage.getItem('showBannerBF')) {
        setTimeout(() => {
          this.getBrn(true);
        }, 2000)
      }
    }
  },
  methods: {
    ...mapActions({
      getBrn: 'auth/bnr'
    }),
    showContacts() {
      this.$refs['backdropModal'].classList.remove('d-none')
      this.$refs['contactsModal'].classList.add('show')
      this.$refs['contactsModal'].classList.add('d-block')
      var a = document.body;
      a.classList.add('modal-open')

    },
    showSale() {
      this.$refs['backdropModal'].classList.remove('d-none')
      this.$refs['salesModal'].classList.add('show')
      this.$refs['salesModal'].classList.add('d-block')
      var a = document.body;
      a.classList.add('modal-open')
    },
    closeContacts() {
      this.$refs['backdropModal'].classList.add('d-none')
      this.$refs['contactsModal'].classList.remove('show')
      this.$refs['contactsModal'].classList.remove('d-block')
      var a = document.body;
      a.classList.remove('modal-open')
    },
    closeSale() {
      this.$refs['backdropModal'].classList.add('d-none')
      this.$refs['salesModal'].classList.remove('show')
      this.$refs['salesModal'].classList.remove('d-block')
      var a = document.body;
      a.classList.remove('modal-open')
      this.getBrn(false);
      localStorage.setItem('showBannerBF','1');
    }
  }
}
</script>
